// Personel Raporları'nın küçük görünüm yardımcıları.

/** Bar colour of a completion rate (green ≥ 80, amber ≥ 50, else red). */
export const rateTone = (rate) => {
  if (rate >= 80) return 'tw-bg-emerald-500';
  if (rate >= 50) return 'tw-bg-amber-500';
  return 'tw-bg-rose-500';
};

/** Up to two initials of a name. */
export const initialsOf = (name) => String(name || '').split(' ').map((part) => part[0]).join('').substring(0, 2);
